import { Component } from '@angular/core';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  constructor(public authService: AuthService) {

  }
  toggle = true;
  sidebarClass = 'col-sm-2';
  rightSidebarClass = 'col-sm-10 nopadding';
  arrowClass = 'toggle-expanded'
  sidebarText = 'd-inline';
  ariaExpanded = true;
  imgSrc = '/icons/bold/collapse-arrow.svg';
  toggleSidebar() {
    if (this.toggle) {
      this.sidebarClass = 'col-sm-1 sidebar-sm';
      this.arrowClass = 'toggle-collapse';
      this.sidebarText = 'd-none';
      this.ariaExpanded = false;
      this.rightSidebarClass = 'col-sm-11 nopadding';
      this.imgSrc = '/icons/bold/expand-arrow.svg';
    } else {
      this.sidebarClass = 'col-sm-2';
      this.arrowClass = 'toggle-expanded';
      this.rightSidebarClass = 'col-sm-10 nopadding';
      this.sidebarText = 'd-inline';
      this.ariaExpanded = true;
      this.imgSrc = '/icons/bold/collapse-arrow.svg';
    }
    this.toggle = !this.toggle;
  }
}
